import { useMemo } from "react";
import { managedByOptions } from "pages/Creators/data";

export const useDropdownMenuItems = ({
  States,
  Cities,
  Companies,
  Languages,
  PrimaryCategories,
  SubCategories,
  TalentAgencyManagers,
  form,
}) => {
  const statesMenuItems = useMemo(
    () => States?.map((s) => ({ value: s.id, label: s.name })) ?? [],
    [States]
  );

  const citiesMenuItems = useMemo(
    () => Cities?.map((c) => ({ value: c.id, label: c.name })) ?? [],
    [Cities]
  );

  const companiesMenuItems = useMemo(
    () =>
      Companies?.map((c) => ({ value: c.id, label: c.company_name })) ?? [],
    [Companies]
  );

  const languageMenuItems = useMemo(
    () => Languages?.map((l) => ({ value: l.id, label: l.name })) ?? [],
    [Languages]
  );

  const primaryCategoriesMenuItems = useMemo(
    () =>
      PrimaryCategories?.map((cat) => ({ value: cat.id, label: cat.name })) ??
      [],
    [PrimaryCategories]
  );

  const talentAgencyManagerMenuItems = useMemo(
    () =>
      TalentAgencyManagers?.map((m) => ({ value: m.id, label: m.name })) ?? [],
    [TalentAgencyManagers]
  );

  const subCategoriesMenuItems = useMemo(() => {
    if (!SubCategories?.length || !form?.primary_categories?.length) return [];

    const countPerPrimary = {};
    (form.sub_categories || []).forEach((subId) => {
      const sub = SubCategories.find((s) => s.id === subId);
      if (sub) {
        countPerPrimary[sub.primary_category_id] =
          (countPerPrimary[sub.primary_category_id] || 0) + 1;
      }
    });

    return form.primary_categories.flatMap((primaryId, index) => {
      const primaryName =
        PrimaryCategories?.find((p) => p.id === primaryId)?.name ??
        `Category ${index + 1}`;

      const subs = SubCategories.filter(
        (cat) => cat.primary_category_id === primaryId
      ).map((cat) => {
        const isSelected = (form.sub_categories || []).includes(cat.id);
        const categoryFull = (countPerPrimary[primaryId] || 0) >= 2;
        return {
          value: cat.id,
          label: cat.name,
          primaryCategoryId: primaryId,
          disabled: categoryFull && !isSelected,
        };
      });

      return [
        {
          value: `__group__${primaryId}`,
          label: `${primaryName} (Select up to 2)`,
          isGroup: true,
        },
        ...subs,
      ];
    });
  }, [SubCategories, form?.primary_categories, form?.sub_categories, PrimaryCategories]);

  return {
    statesMenuItems,
    citiesMenuItems,
    companiesMenuItems,
    languageMenuItems,
    primaryCategoriesMenuItems,
    subCategoriesMenuItems,
    talentAgencyManagerMenuItems,
    managedByMenuItems: managedByOptions,
  };
};